"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = FooterSocials;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _social = _interopRequireDefault(require("../buttons/icons/social.js"));
/* eslint-disable no-unused-vars */
// Packages

// Components

// Styles
const FooterSocialsOptions = _styledComponents.default.div.withConfig({
  displayName: "socials__FooterSocialsOptions",
  componentId: "sc-1a59l8q-0"
})(["column-gap:20px;display:flex;"]);

// Main Component
function FooterSocials({
  professional,
  circleDefaultColor,
  circleActiveColor,
  iconDefaultColor,
  iconActiveColor,
  borderDefaultColor,
  borderActiveColor,
  exclude,
  corporate,
  iconBorderActiveColor,
  iconBorderDefaultColor,
  circleHeight,
  circleWidth
}) {
  const corporateSocials = {
    facebook: "https://www.facebook.com/AtlanticBay/",
    instagram: "https://instagram.com/atlanticbaymortgagegroup/",
    linkedin: "https://www.linkedin.com/company/atlantic-bay-mortgage-group?trk=company_logo"
  };
  let socials = professional;
  if (!professional || Object.values(professional).length === 0 || corporate) socials = corporateSocials;
  const {
    facebook,
    instagram,
    linkedin,
    twitter
  } = socials;
  return /*#__PURE__*/_react.default.createElement(FooterSocialsOptions, {
    className: "social-icons"
  }, facebook && !(exclude !== null && exclude !== void 0 && exclude.includes("facebook")) && /*#__PURE__*/_react.default.createElement(_social.default, {
    icon: "facebook",
    linkAttributes: {
      href: facebook,
      target: "_blank",
      rel: "noreferrer"
    },
    circleDefaultColor: circleDefaultColor,
    borderDefaultColor: borderDefaultColor,
    circleActiveColor: circleActiveColor,
    borderActiveColor: borderActiveColor,
    iconDefaultColor: iconDefaultColor,
    iconActiveColor: iconActiveColor,
    circleWidth: circleWidth,
    circleHeight: circleHeight
  }), linkedin && !(exclude !== null && exclude !== void 0 && exclude.includes("linkedin")) && /*#__PURE__*/_react.default.createElement(_social.default, {
    icon: "linkedin",
    linkAttributes: {
      href: linkedin,
      target: "_blank",
      rel: "noreferrer"
    },
    circleDefaultColor: circleDefaultColor,
    borderDefaultColor: borderDefaultColor,
    circleActiveColor: circleActiveColor,
    borderActiveColor: borderActiveColor,
    iconActiveColor: iconActiveColor,
    iconDefaultColor: iconDefaultColor,
    circleWidth: circleWidth,
    circleHeight: circleHeight
  }), instagram && !(exclude !== null && exclude !== void 0 && exclude.includes("instagram")) && /*#__PURE__*/_react.default.createElement(_social.default, {
    icon: "instagram",
    linkAttributes: {
      href: instagram,
      target: "_blank",
      rel: "noreferrer"
    },
    circleDefaultColor: circleDefaultColor,
    borderDefaultColor: borderDefaultColor,
    circleActiveColor: circleActiveColor,
    borderActiveColor: borderActiveColor,
    iconBorderDefaultColor: iconBorderDefaultColor,
    iconBorderActiveColor: iconBorderActiveColor,
    circleWidth: circleWidth,
    circleHeight: circleHeight
  }), twitter && !(exclude !== null && exclude !== void 0 && exclude.includes("twitter")) && /*#__PURE__*/_react.default.createElement(_social.default, {
    icon: "twitter",
    linkAttributes: {
      href: twitter,
      target: "_blank",
      rel: "noreferrer"
    },
    circleDefaultColor: circleDefaultColor,
    borderDefaultColor: borderDefaultColor,
    circleActiveColor: circleActiveColor,
    borderActiveColor: borderActiveColor,
    iconDefaultColor: iconDefaultColor,
    iconActiveColor: iconActiveColor,
    circleWidth: circleWidth,
    circleHeight: circleHeight
  }), (professional === null || professional === void 0 ? void 0 : professional.zillow) && !(exclude !== null && exclude !== void 0 && exclude.includes("zillow")) && /*#__PURE__*/_react.default.createElement(_social.default, {
    icon: "zillow",
    linkAttributes: {
      href: professional.zillow,
      target: "_blank",
      rel: "noreferrer"
    },
    circleDefaultColor: circleDefaultColor,
    borderDefaultColor: borderDefaultColor,
    circleActiveColor: circleActiveColor,
    borderActiveColor: borderActiveColor,
    iconActiveColor: iconActiveColor,
    iconDefaultColor: iconDefaultColor,
    circleWidth: circleWidth,
    circleHeight: circleHeight
  }), (professional === null || professional === void 0 ? void 0 : professional.slug) && !(exclude !== null && exclude !== void 0 && exclude.includes("web")) && /*#__PURE__*/_react.default.createElement(_social.default, {
    icon: "web",
    linkAttributes: {
      href: (professional === null || professional === void 0 ? void 0 : professional.web) || `https://www.atlanticbay.com/${professional.slug}/`,
      target: "_blank",
      rel: "noreferrer"
    },
    circleDefaultColor: circleDefaultColor,
    circleActiveColor: circleActiveColor,
    borderDefaultColor: borderDefaultColor,
    borderActiveColor: borderActiveColor,
    iconBorderDefaultColor: iconBorderDefaultColor,
    iconBorderActiveColor: iconBorderActiveColor,
    circleWidth: circleWidth,
    circleHeight: circleHeight
  }));
}

// Prop Types
FooterSocials.propTypes = {
  /**
   * Object with properties of professional for current page
   */
  professional: _propTypes.default.shape().isRequired,
  /**
   * Sets height of icon circle
   */
  circleHeight: _propTypes.default.number,
  /**
   * Sets width of icon circle
   */
  circleWidth: _propTypes.default.number,
  /**
   * Sets default color of icon circle
   */
  circleDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of icon circle
   */
  circleActiveColor: _propTypes.default.string,
  /**
   * Sets default color of icon
   */
  iconDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of icon
   */
  iconActiveColor: _propTypes.default.string,
  /**
   * Sets active color of icon border
   */
  iconBorderActiveColor: _propTypes.default.string,
  /**
   * Sets default color of icon border
   */
  iconBorderDefaultColor: _propTypes.default.string,
  /**
   * Sets default color of border around icon circle
   */
  borderDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of border around icon circle
   */
  borderActiveColor: _propTypes.default.string,
  /**
   * Sets title of icon for accessibility
   */
  title: _propTypes.default.string,
  /**
   * Button Functions, e.g. { onClick: () => {}}
   */
  functions: _propTypes.default.shape(),
  /**
   * Link Attributes e.g. { to: "/", target: "_blank"}
   */
  linkAttributes: _propTypes.default.shape(),
  /**
   * What links should be excluded? ["facebook", "web"]
   */
  exclude: _propTypes.default.array,
  /** Should corporate socials be used? */
  corporate: _propTypes.default.bool
};
FooterSocials.defaultProps = {
  circleWidth: 28,
  circleHeight: 28,
  circleDefaultColor: "transparent",
  circleActiveColor: "#3c9dfd",
  // Pacific Blue 2
  borderDefaultColor: "transparent",
  borderActiveColor: "#3c9dfd",
  // Pacific Blue 2,
  iconDefaultColor: undefined,
  iconActiveColor: "#fff",
  iconBorderActiveColor: "#fff",
  corporate: false
};
FooterSocials.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FooterSocials",
  "props": {
    "circleWidth": {
      "defaultValue": {
        "value": "28",
        "computed": false
      },
      "description": "Sets width of icon circle",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "circleHeight": {
      "defaultValue": {
        "value": "28",
        "computed": false
      },
      "description": "Sets height of icon circle",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "circleDefaultColor": {
      "defaultValue": {
        "value": "\"transparent\"",
        "computed": false
      },
      "description": "Sets default color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "circleActiveColor": {
      "defaultValue": {
        "value": "\"#3c9dfd\"",
        "computed": false
      },
      "description": "Sets active color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "borderDefaultColor": {
      "defaultValue": {
        "value": "\"transparent\"",
        "computed": false
      },
      "description": "Sets default color of border around icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "borderActiveColor": {
      "defaultValue": {
        "value": "\"#3c9dfd\"",
        "computed": false
      },
      "description": "Sets active color of border around icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconDefaultColor": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Sets default color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconActiveColor": {
      "defaultValue": {
        "value": "\"#fff\"",
        "computed": false
      },
      "description": "Sets active color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconBorderActiveColor": {
      "defaultValue": {
        "value": "\"#fff\"",
        "computed": false
      },
      "description": "Sets active color of icon border",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "corporate": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Should corporate socials be used?",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "professional": {
      "description": "Object with properties of professional for current page",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": true
    },
    "iconBorderDefaultColor": {
      "description": "Sets default color of icon border",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "title": {
      "description": "Sets title of icon for accessibility",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "functions": {
      "description": "Button Functions, e.g. { onClick: () => {}}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "linkAttributes": {
      "description": "Link Attributes e.g. { to: \"/\", target: \"_blank\"}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "exclude": {
      "description": "What links should be excluded? [\"facebook\", \"web\"]",
      "type": {
        "name": "array"
      },
      "required": false
    }
  }
};